
import { Routes, Route } from 'react-router-dom';
import OrganizationSettings from '@/pages/OrganizationSettings';
import SocialProfiles from '@/components/dashboard/SocialProfiles';
import PlaceholderAddProfile from '@/components/dashboard/PlaceholderAddProfile';
import PlaceholderContent from '@/components/dashboard/PlaceholderContent';
import YouTubeProfileForm from '@/components/dashboard/profiles/YouTubeProfileForm';
import Products from '@/components/dashboard/products/Products';
import OrdersView from '@/components/dashboard/orders/OrdersView';
import Stores from '@/components/dashboard/Stores';
import Customers from '@/components/dashboard/customers/Customers';
import ShopSettings from '@/pages/ShopSettings';
import { useAuth } from '@/contexts/auth';

interface DashboardRoutesProps {
  activePage: string;
  handlePageChange: (pageId: string) => void;
}

const DashboardRoutes = ({ activePage, handlePageChange }: DashboardRoutesProps) => {
  console.log("DashboardRoutes rendering with activePage:", activePage);
  const auth = useAuth();
  
  return (
    <Routes>
      <Route path="settings" element={<OrganizationSettings />} />
      <Route path="shop-settings" element={<ShopSettings />} />
      <Route path="*" element={
        activePage === 'profiles' ? (
          <SocialProfiles 
            handlePageChange={handlePageChange} 
            activePage={activePage} 
            requireSubscription={true}
          />
        ) : activePage === 'calendar' ? (
          <SocialProfiles handlePageChange={handlePageChange} activePage={activePage} />
        ) : activePage === 'reports' ? (
          <SocialProfiles handlePageChange={handlePageChange} activePage={activePage} />
        ) : activePage === 'content' ? (
          <SocialProfiles handlePageChange={handlePageChange} activePage={activePage} />
        ) : activePage === 'add-profile' ? (
          <PlaceholderAddProfile handlePageChange={handlePageChange} />
        ) : activePage === 'add-youtube-profile' ? (
          <YouTubeProfileForm handlePageChange={handlePageChange} />
        ) : activePage === 'products' ? (
          <Products />
        ) : activePage === 'brands' ? (
          <Stores />
        ) : activePage === 'orders' ? (
          <OrdersView handlePageChange={handlePageChange} />
        ) : activePage === 'customers' ? (
          <Customers handlePageChange={handlePageChange} />
        ) : (
          <PlaceholderContent activePage={activePage} />
        )
      } />
    </Routes>
  );
};

export default DashboardRoutes;
